import { render, staticRenderFns } from "./img-thumbnail.vue?vue&type=template&id=a780d34a&scoped=true&"
import script from "./img-thumbnail.vue?vue&type=script&lang=ts&"
export * from "./img-thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./img-thumbnail.vue?vue&type=style&index=0&id=a780d34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a780d34a",
  null
  
)

export default component.exports